import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
//npm i webfontloader
import WebFont from "webfontloader";
import Contenedor from "./elementos/Contenedor";
//react router dom
import { BrowserRouter, Route, Switch } from "react-router-dom";
//npm i react-helmet - favicon,seo
import { Helmet } from "react-helmet";
//imagen - favicon
import favicon from "./imagenes/logo.png";
//componentes
import EditarGasto from "./componentes/EditarGasto";
import GastosPorCategoria from "./componentes/GastosPorCategoria";
import InicioSesion from "./componentes/InicioSesion";
import ListaDeGastos from "./componentes/ListaDeGastos";
import RegistroUsuarios from "./componentes/RegistroUsuarios";
//imagen fondo
import Fondo from "./elementos/Fondo";
//contexto global de la app
import { AuthProvider } from "./contextos/AuthContext";
//ruta privada
import RutaPrivada from "./componentes/RutaPrivada";
//contexto TotalGastadoProvider
import {TotalGastadoProvider} from './contextos/TotalGastadoEnElMesContext';

//npm i webfontloader
WebFont.load({
  //Work+Sans:wght@400;500;700
  google: {
    families: ["Work Sans:400,500,700", "sans-serif"]
  }
});

const Index = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Jorge RG</title>
        <link rel="shortcut icon" href={favicon} type="image/x-icon" />
      </Helmet>
      <AuthProvider>
        <TotalGastadoProvider>
          <BrowserRouter>
            <Contenedor>
              <Switch>
                {/* rutas publicas */}
                <Route path="/iniciar-sesion" component={InicioSesion} />
                <Route path="/crear-cuenta" component={RegistroUsuarios} />
                {/* rutas privadas */}
                <RutaPrivada path="/categorias">
                  <GastosPorCategoria />
                </RutaPrivada>
                <RutaPrivada path="/lista">
                  <ListaDeGastos />
                </RutaPrivada>
                <RutaPrivada path="/editar/:id">
                  <EditarGasto />
                </RutaPrivada>
                <RutaPrivada path="/">
                  <App />
                </RutaPrivada>
              </Switch>
            </Contenedor>
          </BrowserRouter>

        </TotalGastadoProvider>
      </AuthProvider>

      <Fondo />
    </>
  );
};

ReactDOM.render(<Index />, document.getElementById("root"));
